// extracted by css-extract-rspack-plugin
export default {"status":"Dg2XbI64sownS4_B","good":"mS_DWjqH7k7AGheY","bad":"g5mc0pZ5uYUzR5H3","appealStarted":"BFjMaMSZVDgRdP1i"};